
export const recshareMembers = (state) => {
  return state.recshareMembers
}
export const recshare = (state) => {
  return state.recshare
}
export const total = (state) => {
  return state.total
}
export const offset = (state) => {
  return state.offset
}
export const max = (state) => {
  return state.max
}
export const getMemberById = (state) => (id) => {
  return state.recshareMembers.find(item => item.id === id)
}
export const sort = (state) => {
  return state.sort
}
export const order = (state) => {
  return state.order
}
export default {
  recshareMembers,
  recshare,
  total,
  offset,
  max,
  getMemberById,
  sort,
  order
}
